import { render } from "./CourseCreate.vue?vue&type=template&id=09b83f62"
import script from "./CourseCreate.vue?vue&type=script&lang=js"
export * from "./CourseCreate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__